import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
const CloseButton = t0 => {
  const $ = _c(3);
  const {
    onClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classNames("border-0 w-9 h-9 block rounded-full bg-white absolute cursor-pointer text-center top-[calc(130px+var(--visible-promotion-banner-height))] right-2.5", "md:top-[11.5rem] md:right-4", "hover:before:rotate-45 hover:before:scale-125", "hover:after:-rotate-45 hover:after:-scale-125", "before:content-[''] before:absolute before:w-[15px] before:h-0.5 before:bg-gray-light1 before:rounded-sm before:top-1/2 before:transition-all before:duration-300 before:rotate-45 before:left-1/2 before:-ml-[7.5px] before:-mt-px", "after:content-[''] after:absolute after:w-[15px] after:h-0.5 after:bg-gray-light1 after:rounded-sm after:top-1/2 after:transition-all after:duration-300 after:-rotate-45 after:right-1/2 after:-mr-[7.5px] after:-mt-px");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onClick) {
    t2 = <button className={t1} aria-label="Close (Return to Blog page)" type="button" onClick={onClick} />;
    $[1] = onClick;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
CloseButton.propTypes = {
  onClick: PropTypes.func
};
export default CloseButton;